import apis from '@/apis'
import utils from '@/utils'
import { router } from '@/router/index.js'

const common = {
  state: {
    userInfo: {},
    userType: '',
    isNewVersionGame: false,
  },
  mutations: {
    GET_USERINFO(state, data) {
      // data 表示拿登录态时，如果未登录是否跳转登录页
      apis.common.getUserInfo(utils.token('joy_jct')).then((res) => {
        if (res.data.code == 0) {
          state.userInfo = res.data.data
          if (state.userInfo.nick_name && !state.userInfo.nickName) {
            state.userInfo.nickName = state.userInfo.nick_name
          }

          // komoe台湾判断是否是第三方登录
          if (state.userInfo.hasOwnProperty('loginType')) {
            if (state.userInfo['loginType'] == 0) {
              state.userType = 'account'
            } else {
              state.userType = 'third'
            }
          }
        }
        if (data) {
          if (res.data.code == -101) {
            router.push({
              path: '/login',
              query: {
                redirect: location.href
              }
            })
          }
        }
      })
    },
    GET_USERTYPE(state) {
      // 新版登录获取用户类型，是账号登陆还是三方登录
      apis.common.getOauth().then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.channel_type == 0) {
            state.userType = 'account'
          } else {
            state.userType = 'third'
          }
        }
        
        // 第三方帐号登陆不允许打开账号管理页面
        if (state.userType !== 'account') {
          if (window.location.pathname === '/account') {
            router.push({
              name: 'home'
            })
          }
        }
      })
    },
    CLEAR_USERINFO(state) {
      state.userInfo = {}
    },
    // 存是否是新版本游戏标示
    SET_ISNEWVERSIONGAME(state, data) {
      state.isNewVersionGame = data;
    }
  },
  actions: {
    logoutSlient(state) {
      apis.common.logOut(true).then((res) => {
        if (res.data.code == 0) {
          state.userInfo = {}
        }
      })
    },
    getUserInfo({ commit }, data) {
      commit('GET_USERINFO', data)
    },
    getUserType({ commit }) {
      commit('GET_USERTYPE')
    },
    clearUserInfo({ commit }) {
      commit('CLEAR_USERINFO')
    }
  },
  getters: {
    userInfo: (s) => s.userInfo,
    userType: (s) => s.userType
  }
}

export default common
